import { render, staticRenderFns } from "./TouchpointStatisticsOverviewRow.vue?vue&type=template&id=477d592a&scoped=true&"
import script from "./TouchpointStatisticsOverviewRow.vue?vue&type=script&lang=js&"
export * from "./TouchpointStatisticsOverviewRow.vue?vue&type=script&lang=js&"
import style0 from "../../../../Style/touchpoint-statistics-row.scss?vue&type=style&index=0&id=477d592a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477d592a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Projects\\Werk\\MarketingDbNEW\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('477d592a')) {
      api.createRecord('477d592a', component.options)
    } else {
      api.reload('477d592a', component.options)
    }
    module.hot.accept("./TouchpointStatisticsOverviewRow.vue?vue&type=template&id=477d592a&scoped=true&", function () {
      api.rerender('477d592a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/TouchpointOverview/Statistics/TouchpointStatisticsOverviewRow.vue"
export default component.exports